import { Link, useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect, useState, useRef } from "react"

import { setChatRole, useChatList } from "../../utils/api"

import styles from "./styles.module.scss"

import { Icon } from "components"
import { RoleType } from "utils/constants"
import { AppDispatch } from "utils/store/store"

interface ChatWidgetProps {
    role: RoleType
}

export function ChatWidget({ role }: ChatWidgetProps) {
    const dispatch = useDispatch<AppDispatch>()
    const location = useLocation()
    const [bottomOffset, setBottomOffset] = useState(16)
    const footerRef = useRef<HTMLElement | null>(null)
    const { data: chats = [], refetch } = useChatList(role)
    const unreadCount = chats.reduce((sum, chat) => sum + chat.unreadCount, 0)

    useEffect(() => {
        void refetch()
    }, [dispatch, role, location.pathname])

    useEffect(() => {
        const footer = document.querySelector(".alter-footer") as HTMLElement
        footerRef.current = footer

        if (!footer) return

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    const footerHeight = footer.offsetHeight
                    setBottomOffset(footerHeight + 16)
                } else {
                    setBottomOffset(16)
                }
            },
            { threshold: 0.1 }
        )

        observer.observe(footer)
        return () => observer.disconnect()
    }, [])

    const onWidgetClick = () => {
        dispatch(setChatRole(role))
    }

    return (
        <Link
            to="/chat"
            className={styles.widget}
            onClick={onWidgetClick}
            style={{ bottom: `${bottomOffset}px` }}
        >
            <Icon type="comment" size={24} className={styles.icon} />
            {unreadCount > 0 && <span className={styles.badge}>{unreadCount}</span>}
        </Link>
    )
}
